
define('ldsh!modules/office_data/create/template', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h1>OfficeData</h1>\n<div class="form form-horizontal" role="form">\n\n\n\n\n  \n\n  <div class="form-group">\n    <label for="office">office</label>\n    <select  class="form-control selectbox-office" id="office" name="office" ></select>\n  </div>\n\n\n\n\n\n\n\n\n  <button type="button" class="btn btn-default submitForm">Submit</button>\n</div>';

}
return __p
};});

